import { api } from '@/lib/api';

const KEY = 'mt_token';

export function getToken() { return localStorage.getItem(KEY); }
export function setToken(t) { localStorage.setItem(KEY, t); }
export function clearToken() { localStorage.removeItem(KEY); }
export function isLoggedIn() { return !!getToken(); }

// Attach Bearer header on every request
api.interceptors.request.use((cfg) => {
    const t = getToken();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    /* Inject ?lang=fr for public API calls when the user is on a /fr/* URL
       so the backend applies the bilingual resolver + publication rules.
       Admin endpoints (which live under /api/admin/*) are excluded. */
    try {
        const path = typeof window !== 'undefined' ? window.location.pathname : '';
        const isFr = path === '/fr' || path.startsWith('/fr/');
        const url = cfg.url || '';
        const isAdmin = /\/admin\//.test(url) || /\/auth\//.test(url);
        if (isFr && !isAdmin) {
            cfg.params = { ...(cfg.params || {}), lang: 'fr' };
        }
    } catch (_) { /* ignore */ }
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) clearToken();
        return Promise.reject(err);
    }
);

export const login = (email, password) =>
    api.post('/auth/login', { email, password }).then((r) => {
        setToken(r.data.token);
        return r.data;
    });

export const fetchMe = () => api.get('/auth/me').then((r) => r.data);
